import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppletContainerModel} from '../../../../../models/aggregates/applet/applet-container.model';
import {Pagination} from '../shared/pagination.model';
import {ApiVisa} from '../shared/api-visa.model';
import {PagingResponseModel} from '../shared/api-response.model';
import {Core2Config} from '../shared/core2Config';


@Injectable({providedIn: 'root'})
export class AppletHeaderService extends BaseApiTemplateService<AppletContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'pg/' + 'bl_applet_hdr/headers';
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + 'pg/' + 'bl_applet_hdr/headers';
    this.httpClient = http;
  }

  public getByCriteriaPromise(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Promise<PagingResponseModel<AppletContainerModel>> {
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    console.log('url ' + UrlByCriteria);
    return this.httpClient.get<PagingResponseModel<AppletContainerModel>>(UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

}
